export default __webpack_public_path__ + "static/media/what-we-do-small-ellipse.1ba82fd7.svg";